/** @format */

import { useState, useCallback, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export const useMenu = (path) => {
	const location = useLocation();
	const page = location.pathname.split('/').slice(2)[0];
	const selected = page === path;
	const navItemRef = useRef();
	const [onHover, setOnHover] = useState(false);

	const onMouseEnter = useCallback(() => {
		setOnHover(true);
	}, [setOnHover]);
	const onMouseLeave = useCallback(() => {
		setOnHover(false);
	}, [setOnHover]);

	return {
		selected,
		navItemRef,
		onHover,
		onMouseEnter,
		onMouseLeave
	};
};
